import { render, staticRenderFns } from "./CrossMark.vue?vue&type=template&id=aa3bb2b8&scoped=true&"
import script from "./CrossMark.vue?vue&type=script&lang=js&"
export * from "./CrossMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3bb2b8",
  null
  
)

export default component.exports